(() => {
  if (!customElements.get('cc-product')) {
    class CcProduct extends HTMLElement {
      connectedCallback() {
        const data = this.querySelector('[data-cc-variants]');
        this.variants = data ? JSON.parse(data.textContent) : [];
        this.form = this.querySelector('form[data-type="add-to-cart-form"]');
        this.idInput = this.form ? this.form.querySelector('[name="id"]') : null;
        this.addButton = this.querySelector('[data-cc-add]');
        this.addLabel = this.querySelector('[data-cc-add-label]');
        this.mainSlider = this.querySelector('[data-cc-main]');

        this.querySelectorAll('[data-cc-option]').forEach((input) => {
          input.addEventListener('change', () => this.onOptionChange());
        });

        this.initGallery();
        this.initRating();
        this.initUpsells();
        this.initShare();
        this.markAvailability();
      }

      getSelectedOptions() {
        const selected = [];
        this.querySelectorAll('[data-cc-option]:checked').forEach((input) => {
          selected[Number(input.dataset.position) - 1] = input.value;
        });
        return selected;
      }

      onOptionChange() {
        const selected = this.getSelectedOptions();
        const variant = this.variants.find((v) => v.options.every((value, i) => value === selected[i]));
        this.querySelectorAll('[data-cc-option-current]').forEach((el) => {
          el.textContent = selected[Number(el.dataset.ccOptionCurrent) - 1] || '';
        });
        this.markAvailability();
        this.updateVariant(variant);
      }

      markAvailability() {
        const selected = this.getSelectedOptions();
        this.querySelectorAll('[data-cc-option]').forEach((input) => {
          const pos = Number(input.dataset.position) - 1;
          const available = this.variants.some(
            (v) => v.available && v.options[pos] === input.value && v.options.every((val, i) => i === pos || i > pos || val === selected[i])
          );
          input.classList.toggle('is-unavailable', !available);
        });
      }

      updateVariant(variant) {
        if (!this.addButton) return;
        if (!variant) {
          this.addButton.disabled = true;
          this.addLabel.textContent = this.addButton.dataset.unavailable;
          return;
        }

        if (this.idInput) {
          this.idInput.value = variant.id;
          this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        this.addButton.disabled = !variant.available;
        this.addLabel.textContent = variant.available ? this.addButton.dataset.add : this.addButton.dataset.soldout;

        const price = this.querySelector('[data-cc-price]');
        const compare = this.querySelector('[data-cc-compare]');
        const badge = this.querySelector('[data-cc-badge]');
        if (price) price.textContent = variant.price;
        if (compare) {
          compare.textContent = variant.compare || '';
          compare.hidden = !variant.compare;
        }
        if (badge) {
          badge.hidden = !variant.off;
          badge.textContent = (badge.dataset.template || '[off]% OFF').replace('[off]', variant.off);
        }

        if (variant.media) this.goToMedia(variant.media);

        if (this.dataset.updateUrl !== 'false') {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      initGallery() {
        if (!this.mainSlider) return;
        this.slides = [...this.mainSlider.querySelectorAll('[data-cc-slide]')];
        this.thumbs = [...this.querySelectorAll('[data-cc-thumb]')];
        this.dots = [...this.querySelectorAll('[data-cc-dot]')];
        this.lightbox = this.querySelector('[data-cc-lightbox]');

        this.thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => this.goToIndex(index)));
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goToIndex(index)));
        this.currentIndex = 0;
        // Arrows: the chevrons over the photo (phones) and the ones beside the thumbnails (computers).
        const last = this.slides.length - 1;
        this.querySelectorAll('[data-cc-prev]').forEach((b) => b.addEventListener('click', () => this.goToIndex(this.currentIndex > 0 ? this.currentIndex - 1 : last)));
        this.querySelectorAll('[data-cc-next]').forEach((b) => b.addEventListener('click', () => this.goToIndex(this.currentIndex < last ? this.currentIndex + 1 : 0)));

        let ticking = false;
        this.mainSlider.addEventListener('scroll', () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            const step = this.slides[1] ? this.slides[1].offsetLeft - this.slides[0].offsetLeft : this.mainSlider.clientWidth;
            const index = Math.min(this.slides.length - 1, Math.round(this.mainSlider.scrollLeft / step));
            this.setCurrent(index);
            ticking = false;
          });
        });

        if (this.lightbox) this.initLightbox();

        // The frame is as tall as the photo the rail has stopped on (buchan.store): nothing moves while the rail
        // scrolls; when it settles, the frame height eases to the new photo. Several fast swipes only retarget it.
        this.frame = this.querySelector('[data-cc-frame]');
        const heightOf = (slide) => {
          const ratio = Number(slide.dataset.ratio) || 1;
          return Math.round(slide.clientWidth / ratio) || slide.offsetHeight;
        };
        const settledIndex = () => {
          const step = this.slides[1] ? this.slides[1].offsetLeft - this.slides[0].offsetLeft : this.mainSlider.clientWidth;
          return Math.max(0, Math.min(this.slides.length - 1, Math.round(this.mainSlider.scrollLeft / (step || 1))));
        };
        this.fitHeight = (animate = true) => {
          if (!this.frame || !this.slides.length) return;
          if (window.innerWidth < 990) { this.frame.style.height = ''; return; }   // GABINS: phone = fixed 3:4 frame, no height change
          const h = heightOf(this.slides[settledIndex()]);
          if (!h) return;
          if (!animate) this.frame.style.transition = 'none';
          this.frame.style.height = h + 'px';
          if (!animate) { void this.frame.offsetHeight; this.frame.style.transition = ''; }
          this.mainSlider.dispatchEvent(new CustomEvent('cc:gallery-height', { bubbles: true }));
        };
        // When the swipe lands on another photo and the top of the gallery has gone above the screen (tall photo ->
        // shorter one), glide back to the top of the photo and give it a quick fade-in.
        this.lastSettled = 0;
        const headerEl = () => document.querySelector('.shopify-section-group-header-group:has(.cc-header)') || document.querySelector('.cc-header') || document.querySelector('header');
        // Phone / tablet: while the visitor swipes the photos the navbar is useless, it glides and fades away
        // (0.6 s, same easing as it comes back) and only returns when the visitor scrolls back up.
        let navHidden = false;
        const hideNav = () => {
          const hdr = headerEl();
          if (!hdr || navHidden || window.innerWidth >= 990) return;
          navHidden = true;
          hdr.style.transition = 'transform .6s cubic-bezier(.22,.61,.36,1), opacity .6s cubic-bezier(.22,.61,.36,1)';
          hdr.style.transform = 'translateY(-105%)';
          hdr.style.opacity = '0';
          let lastY = null;
          setTimeout(() => { lastY = window.scrollY; }, 750);
          const onScroll = () => {
            if (lastY === null) return;
            if (window.scrollY < lastY - 12 || window.scrollY <= 0) {
              hdr.style.transform = '';
              hdr.style.opacity = '';
              navHidden = false;
              window.removeEventListener('scroll', onScroll);
            } else if (window.scrollY > lastY) lastY = window.scrollY;
          };
          window.addEventListener('scroll', onScroll, { passive: true });
        };
        const glideTo = (delta) => {
          // Slow, eased scroll (600 ms) instead of the browser's quick jump.
          const from = window.scrollY, to = Math.max(0, from + delta), t0 = performance.now();
          const ease = (t) => 1 - Math.pow(1 - t, 3);
          const step = (now) => {
            const t = Math.min(1, (now - t0) / 600);
            window.scrollTo(0, from + (to - from) * ease(t));
            if (t < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        };
        let swiping = false;
        this.mainSlider.addEventListener('touchstart', () => { swiping = true; }, { passive: true });
        this.mainSlider.addEventListener('pointerdown', () => { swiping = true; }, { passive: true });
        this.mainSlider.addEventListener('scroll', () => { if (swiping && window.innerWidth >= 990) hideNav(); }, { passive: true });   // GABINS: no navbar hide on phone
        const reveal = (idx, changed) => {
          if (!this.frame) return;
          const hdr = headerEl();
          const hh = hdr ? Math.min(180, hdr.offsetHeight) : 0;
          const top = this.frame.getBoundingClientRect().top;
          if (window.innerWidth < 990) {
            // Phone / tablet: every swipe puts the photo at the very top of the screen, navbar out of the way.
            hideNav();
            if (Math.abs(top) > 2) glideTo(top);
          } else if (changed && top < hh - 2) {
            // Computer: the sticky navbar stays, keep room for its full height.
            window.scrollTo({ top: window.scrollY + top - hh - 8, behavior: 'smooth' });
          }
          const img = this.slides[idx] && this.slides[idx].querySelector('img');
          if (changed && img && img.animate) img.animate([{ opacity: 0.6, transform: 'scale(0.99)' }, { opacity: 1, transform: 'none' }], { duration: 520, easing: 'cubic-bezier(.22,.61,.36,1)' });
        };
        let settleTimer = 0;
        const onSettle = () => {
          clearTimeout(settleTimer);
          this.fitHeight(true);
          const idx = settledIndex();
          if (idx !== this.lastSettled) {
            // Only when the new photo is a different height: same-size photos just slide, nothing moves.
            const prev = this.slides[this.lastSettled], next = this.slides[idx];
            const changed = prev && next && Math.abs(heightOf(prev) - heightOf(next)) > 4;
            this.lastSettled = idx;
            swiping = false;
            if (changed && window.innerWidth >= 990) reveal(idx, changed);   // GABINS: phone = the page never moves on swipe
          }
        };
        this.mainSlider.addEventListener('scroll', () => {
          clearTimeout(settleTimer);
          settleTimer = setTimeout(onSettle, 70);   // browsers without the scrollend event
        }, { passive: true });
        this.mainSlider.addEventListener('scrollend', onSettle);
        window.addEventListener('resize', () => this.fitHeight(false));
        window.addEventListener('load', () => this.fitHeight(false));
        this.fitHeight(false);
      }

      initRating() {
        const reviews = document.querySelector('cc-reviews[data-count]');
        this.querySelectorAll('[data-cc-rating]').forEach((link) => {
          const count = Number(link.dataset.fixedCount) || 3687;
          const average = reviews && Number(reviews.dataset.count) > 0
            ? Number(reviews.dataset.average)
            : Number(link.dataset.defaultRating) || 4.7;
          link.querySelector('[data-cc-rating-fill]').style.width = Math.min(100, (average / 5) * 100) + '%';
          link.querySelector('[data-cc-rating-text]').textContent = (link.dataset.template || '[rating] - [count] Reviews')
            .replace('[rating]', average.toFixed(1))
            .replace('[count]', count);
          link.hidden = false;
        });
      }

      initLightbox() {
        const box = this.lightbox;
        const data = box.querySelector('[data-cc-lightbox-data]');
        this.lbItems = data ? JSON.parse(data.textContent) : [];
        this.lbStage = box.querySelector('[data-cc-lightbox-stage]');
        this.lbImg = box.querySelector('[data-cc-lightbox-img]');
        this.lbCounter = box.querySelector('[data-cc-lightbox-counter]');
        this.lbIndex = 0;

        this.slides.forEach((slide, index) => slide.addEventListener('click', () => this.openLightbox(index)));
        box.querySelector('[data-cc-lightbox-close]').addEventListener('click', () => box.close());
        const prev = box.querySelector('[data-cc-lightbox-prev]');
        const next = box.querySelector('[data-cc-lightbox-next]');
        if (prev) prev.addEventListener('click', () => this.showLightbox(this.lbIndex - 1));
        if (next) next.addEventListener('click', () => this.showLightbox(this.lbIndex + 1));
        box.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.showLightbox(this.lbIndex - 1);
          if (event.key === 'ArrowRight') this.showLightbox(this.lbIndex + 1);
        });
        box.addEventListener('close', () => {
          this.setZoom(false);
          if (history.state && history.state.ccDialog === 'lightbox') history.back();
        });
        window.addEventListener('popstate', () => { if (box.open) box.close(); });

        // Click / tap toggles the zoom at that point; moving the mouse or the finger pans the zoomed image.
        const originFrom = (x, y) => {
          const rect = this.lbStage.getBoundingClientRect();
          const px = Math.min(100, Math.max(0, ((x - rect.left) / rect.width) * 100));
          const py = Math.min(100, Math.max(0, ((y - rect.top) / rect.height) * 100));
          this.lbImg.style.transformOrigin = px + '% ' + py + '%';
        };
        let touchStart = null;
        let moved = false;
        this.lbStage.addEventListener('click', (event) => {
          if (moved) { moved = false; return; }
          originFrom(event.clientX, event.clientY);
          this.setZoom(!this.lbStage.classList.contains('is-zoomed'));
        });
        this.lbStage.addEventListener('mousemove', (event) => {
          if (this.lbStage.classList.contains('is-zoomed')) originFrom(event.clientX, event.clientY);
        });
        this.lbStage.addEventListener('touchstart', (event) => {
          const t = event.touches[0];
          touchStart = { x: t.clientX, y: t.clientY };
          moved = false;
        }, { passive: true });
        this.lbStage.addEventListener('touchmove', (event) => {
          if (!touchStart) return;
          const t = event.touches[0];
          if (Math.abs(t.clientX - touchStart.x) > 8 || Math.abs(t.clientY - touchStart.y) > 8) moved = true;
          if (this.lbStage.classList.contains('is-zoomed')) {
            // Drag the image under the finger: move the zoom origin the opposite way.
            const rect = this.lbStage.getBoundingClientRect();
            originFrom(rect.left + rect.width - (t.clientX - rect.left), rect.top + rect.height - (t.clientY - rect.top));
            event.preventDefault();
          }
        }, { passive: false });
        this.lbStage.addEventListener('touchend', (event) => {
          if (!touchStart) return;
          const t = event.changedTouches[0];
          const dx = t.clientX - touchStart.x;
          if (!this.lbStage.classList.contains('is-zoomed') && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(t.clientY - touchStart.y)) {
            this.showLightbox(this.lbIndex + (dx < 0 ? 1 : -1));
          }
          touchStart = null;
        });
      }

      openLightbox(index) {
        this.lightbox.showModal();
        history.pushState({ ccDialog: 'lightbox' }, '');
        this.showLightbox(index);
      }

      showLightbox(index) {
        const count = this.lbItems.length;
        if (!count) return;
        this.lbIndex = (index + count) % count;
        const item = this.lbItems[this.lbIndex];
        this.setZoom(false);
        this.lbImg.src = item.src;
        this.lbImg.alt = item.alt || '';
        if (this.lbCounter) this.lbCounter.textContent = this.lbIndex + 1 + ' / ' + count;
      }

      setZoom(on) {
        if (!this.lbStage) return;
        this.lbStage.classList.toggle('is-zoomed', on);
      }

      goToMedia(mediaId) {
        const index = this.slides ? this.slides.findIndex((s) => Number(s.dataset.mediaId) === Number(mediaId)) : -1;
        if (index > -1) this.goToIndex(index);
      }

      goToIndex(index) {
        if (!this.mainSlider) return;
        const slide = this.slides[index];
        if (slide) this.mainSlider.scrollTo({ left: slide.offsetLeft - this.slides[0].offsetLeft, behavior: 'smooth' });
        this.setCurrent(index);
      }

      setCurrent(index) {
        this.currentIndex = index;
        const thumbList = this.querySelector('[data-cc-thumbs]');
        const thumb = this.thumbs && this.thumbs[index];
        if (thumbList && thumb) {
          thumbList.scrollTo({ left: thumb.offsetLeft - (thumbList.clientWidth - thumb.clientWidth) / 2, behavior: 'smooth' });
        }
        [...(this.thumbs || []), ...(this.dots || [])].forEach((el) => {
          const isCurrent = Number(el.dataset.index) === index;
          el.setAttribute('aria-current', isCurrent ? 'true' : 'false');
        });
      }

      initUpsells() {
        this.querySelectorAll('[data-cc-upsell-item]').forEach((item) => {
          const select = item.querySelector('select');
          const price = item.querySelector('[data-cc-upsell-price]');
          const qty = item.querySelector('input[type="number"]');
          if (select && price) {
            select.addEventListener('change', () => {
              price.textContent = select.selectedOptions[0].dataset.price;
            });
          }
          item.querySelectorAll('[data-cc-step]').forEach((btn) =>
            btn.addEventListener('click', () => {
              const next = Math.max(1, Number(qty.value) + Number(btn.dataset.ccStep));
              qty.value = next;
            })
          );
        });

        const productForm = this.querySelector('product-form');
        if (!productForm || !this.form) return;

        // Runs in the capture phase so checked add-ons reach the cart before the theme's product-form refreshes the drawer.
        productForm.addEventListener(
          'submit',
          async (event) => {
            if (this.upsellsAdded) {
              this.upsellsAdded = false;
              return;
            }
            const items = [...this.querySelectorAll('[data-cc-upsell-item]')]
              .filter((item) => item.querySelector('[data-cc-upsell-check]').checked)
              .map((item) => ({
                id: Number(item.querySelector('[data-cc-upsell-variant]').value),
                quantity: Math.max(1, Number(item.querySelector('input[type="number"]').value) || 1),
              }));
            if (!items.length) return;

            event.preventDefault();
            event.stopPropagation();
            try {
              await fetch(`${window.Shopify && Shopify.routes ? Shopify.routes.root : '/'}cart/add.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ items }),
              });
            } catch (error) {
              console.error(error);
            }
            this.upsellsAdded = true;
            this.form.requestSubmit();
          },
          true
        );
      }

      initShare() {
        const button = this.querySelector('[data-cc-share]');
        if (!button) return;
        button.addEventListener('click', async () => {
          const url = button.dataset.url;
          if (navigator.share) {
            try {
              await navigator.share({ url, title: document.title });
            } catch (e) {}
            return;
          }
          try {
            await navigator.clipboard.writeText(url);
            const label = button.querySelector('span');
            const original = label.textContent;
            label.textContent = button.dataset.copied;
            setTimeout(() => (label.textContent = original), 2000);
          } catch (e) {}
        });
      }
    }
    customElements.define('cc-product', CcProduct);
  }

  if (!customElements.get('cc-slideshow')) {
    class CcSlideshow extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-cc-track]');
        this.slides = [...this.querySelectorAll('[data-cc-slideshow-slide]')];
        this.dots = [...this.querySelectorAll('[data-cc-slideshow-dot]')];
        this.index = 0;
        if (this.slides.length < 2) return;

        this.querySelector('[data-cc-prev]').addEventListener('click', () => this.go(this.index - 1));
        this.querySelector('[data-cc-next]').addEventListener('click', () => this.go(this.index + 1));
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));

        const speed = Number(this.dataset.speed) * 1000;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.autoplay === 'true' && speed && !reduceMotion) {
          this.timer = setInterval(() => this.go(this.index + 1), speed);
          this.addEventListener('mouseenter', () => clearInterval(this.timer));
        }

        let startX = 0;
        this.addEventListener('touchstart', (e) => (startX = e.touches[0].clientX), { passive: true });
        this.addEventListener('touchend', (e) => {
          const delta = e.changedTouches[0].clientX - startX;
          if (Math.abs(delta) > 50) this.go(this.index + (delta < 0 ? 1 : -1));
        });
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      go(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.track.style.transform = `translateX(-${this.index * 100}%)`;
        this.slides.forEach((s, i) => s.setAttribute('aria-hidden', i === this.index ? 'false' : 'true'));
        this.dots.forEach((d, i) => d.setAttribute('aria-current', i === this.index ? 'true' : 'false'));
      }
    }
    customElements.define('cc-slideshow', CcSlideshow);
  }
})();


/* GABINS x Moon Bundles : le style et le comportement de l'offre sont dans gabins-moon.js (charge seulement sur les pages produit). */
(function () {
  if (!document.querySelector('cc-product') || document.getElementById('gabins-moon-js')) return;
  var me = document.currentScript || document.querySelector('script[src*="gabins.js"]');
  if (!me || !me.src) return;
  var s = document.createElement('script');
  s.id = 'gabins-moon-js';
  s.src = me.src.replace('gabins.js', 'gabins-moon.js');
  document.head.appendChild(s);
})();
